import { useEffect, useState } from "react";

export default function FeedbackBar({ message, success }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (success != null) {
      setVisible(true);
      setTimeout(() => setVisible(false), 3000);
    }
  }, [message, success]);

  return (
    <>
      {visible && (
        <div
          className={`fixed 
            top-0 left-0 right-0 
            p-4 text-center 
            text-white 
            animate-slideDownAndFade z-[60] 
            ${success ? "bg-primary-validate" : "bg-primary-danger"}`}
        >
          {message}
        </div>
      )}
    </>
  );
}
